import { FC, ReactElement, useMemo } from 'react'

import { ValkTalkPostsFilterContainer } from '../../../containers/@filters/ValkTalkPostsFilterContainer/ValkTalkPostsFilterContainer'
import { ValkTalkFeedType } from '../../../entities/ValkTalkPost/ValkTalkPost'
import { getPermittedFeedTypes } from '../../../entities/ValkTalkPost/ValkTalkPostHelpers'
import usePermissions from '../../../helpers/hooks/usePermissions'
import { useTypedDispatch, useTypedSelector } from '../../../redux/store'
import { setFeedTypes, setIsAddPostModalOpen, setOnlyOwnPosts } from '../../../redux/valkTalkPosts/valkTalkPostsReducer'

interface ConnectedValkTalkPostsFilterProps {
    className?: string
}

export const ConnectedValkTalkPostsFilter: FC<ConnectedValkTalkPostsFilterProps> = ({ className = '' }): ReactElement => {
    const dispatch = useTypedDispatch()
    const permissions = usePermissions()
    const { feedTypes, onlyOwnPosts } = useTypedSelector(state => state.valkTalkPostsReducer)

    const canAddPost = useMemo(() => !! getPermittedFeedTypes(permissions).length, [permissions])

    const handleAddPostClick = (): void => {
        dispatch(setIsAddPostModalOpen(true))
    }

    const handleFeedTypesChange = (selectedFeedTypes: ValkTalkFeedType[]): void => {
        dispatch(setFeedTypes(selectedFeedTypes))
    }

    const handleOnlyOwnPostsChange = (isChecked: boolean): void => {
        dispatch(setOnlyOwnPosts(isChecked))
    }

    return (
        <ValkTalkPostsFilterContainer
            canAddPost={canAddPost}
            feedTypes={feedTypes}
            onlyOwnPosts={onlyOwnPosts}
            onAddPostClick={handleAddPostClick}
            onFeedTypesChange={handleFeedTypesChange}
            onOnlyOwnPostsChange={handleOnlyOwnPostsChange}
            className={className}
        />
    )
}
